import styled from 'styled-components/macro'
import { colorStyle, compose, typography } from 'styled-system'

export const TextButton = styled.button.attrs<{ color: string }>({
  colors: 'link.primary',
  fontSize: 3,
})`
  ${compose(colorStyle, typography)}
  border: none;
  padding: 0;
  background-color: transparent;
  text-decoration: underline;
  cursor: pointer;
  ${({ color }) => color && `color: ${color}`};
`
